var i = /* @__PURE__ */ ((e) => (e.Line = "line", e.Duo = "duo", e.Filled = "filled", e))(i || {});
export {
  i as I
};
